
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Thirtytwoseaterbusrentinpune() {



  const cardData =
  {
    keyword: ' 32 Seater Bus Rent in Pune',
    heading: 'Vaishnavi Travels: 32 Seater Bus Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers reliable and budget-friendly 32 Seater Bus Rent in Pune, ideal for weddings, corporate outings, school trips, and family tours. Our buses are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring a smooth and comfortable journey for large groups. With professional drivers, punctual pickups, and flexible booking options, we make group travel simple and stress-free. Whether it’s a religious yatra, destination wedding, picnic, or long outstation tour, Vaishnavi Travels guarantees safe, reliable, and comfortable 32 seater bus rental services in Pune for every occasion.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Once the seat of power of the Maratha Empire, its mighty gates, sprawling gardens, and ruined bastions narrate tales of valor and glory. Though partially destroyed by a fire in 1828, the fort still stands as a majestic landmark. The evening light-and-sound show recreates the romance of Bajirao and Mastani and the grandeur of the Peshwas. Thousands of visitors explore its corridors, courtyards, and gardens every day. Shaniwar Wada remains Pune’s proud cultural and historic centerpiece."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument closely tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its majestic Italian arches, sprawling lawns, and colonial architecture make it a popular attraction. Tourists enjoy the calm and serene ambiance of its gardens while soaking in history. Aga Khan Palace stands as Pune’s inspirational monument of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 25 km from Pune, Sinhagad Fort is famous for the 1670 battle in which Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers panoramic views of the Sahyadris and trekking opportunities for adventure lovers. The fort is dotted with ancient bastions, temples, and memorials echoing Maratha bravery. In monsoon, mist and waterfalls add a magical touch to the trek. Local villagers serve traditional pithla-bhakri, making the trip even more authentic. Sinhagad is Pune’s perfect mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple is famous for its magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of vibrant celebrations attracting lakhs of devotees. Beyond rituals, the temple is renowned for its charitable, cultural, and social initiatives. Tourists and devotees alike experience the spiritual energy and grandeur here. Dagdusheth Ganpati is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, a sanctum, and a Nandi mandapa, it is a fine example of early Indian rock-cut architecture. Despite being located in the city center, the temple offers a peaceful and meditative environment. Evening prayers and chants fill the air with devotion and serenity. Tourists admire the craftsmanship and historical charm of this hidden heritage site. Pataleshwar Cave Temple is Pune’s spiritual retreat in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits range from musical instruments, sculptures, and ornaments to everyday household objects of past centuries. The recreated Mastani Mahal is a highlight that fascinates history lovers. Students and tourists find the museum both educational and inspiring. It preserves India’s cultural traditions and artistry across eras. Raja Dinkar Kelkar Museum is Pune’s proud celebration of heritage, history, and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city from its hilltop temple complex. The Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and museums nearby add cultural depth to the visit. Visitors climb 103 stone steps to reach the top, combining devotion with a healthy trek. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic escape above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort, located in Koregaon Park, is Pune’s global destination for spirituality, wellness, and mindfulness. Spread across beautifully landscaped gardens, it attracts seekers and tourists from across the world. The ashram offers meditation techniques, yoga practices, and personal growth workshops. Japanese Zen gardens and tranquil meditation halls create a serene atmosphere. Beyond spirituality, it promotes rejuvenation and holistic living. Osho Ashram is Pune’s international hub of peace, healing, and inner growth."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Inspired by the famous Korakuen Garden in Japan, Pu La Deshpande Garden is Pune’s largest landscaped park. It is designed with flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, peaceful walks, and photography in this lush setting. The garden is also a symbol of Indo-Japanese cultural friendship. Nature lovers find it refreshing throughout the year, especially in spring. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built across the Mutha River, is a popular weekend spot just outside Pune. It not only supplies water to the city but also offers stunning views of hills, backwaters, and sunsets. In monsoon, the overflowing dam creates breathtaking sights. Locals and tourists enjoy roadside snacks like roasted corn and tea along the banks. It is also the starting point for trips to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway for families and travelers alike."
  }
],


 "services": [
  {
    "name": "32 Seater Bus Hire Pune",
    "description": "Reliable 32 seater bus hire service in Pune, perfect for medium-sized groups requiring comfortable and efficient transportation. Suitable for weddings, corporate events, school trips, and family outings with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Mid-Size Bus Rental Pune",
    "description": "Affordable mid-size bus rental options in Pune, ideal for group travel with balanced seating capacity and ample luggage space. These buses offer a smooth ride with safety features and are available for local and outstation trips."
  },
  {
    "name": "AC 32 Seater Bus Pune",
    "description": "Air-conditioned 32 seater buses in Pune providing a cool and comfortable travel experience. Equipped with modern interiors and entertainment systems, these buses are great for weddings, corporate events, and long-distance journeys."
  },
  {
    "name": "Wedding 32 Seater Bus Booking",
    "description": "Specialized 32 seater bus booking services for weddings in Pune, ensuring timely and elegant transportation for guests. Options for decorated buses, flexible scheduling, and courteous drivers make your wedding travel hassle-free."
  },
  {
    "name": "Corporate 32 Seater Bus Hire Pune",
    "description": "Professional 32 seater bus hire tailored for corporate events and employee transportation in Pune. Punctual, comfortable, and equipped with amenities to ensure a productive and pleasant journey for business groups."
  },
  {
    "name": "32 Seater School Trip Bus",
    "description": "Safe and reliable 32 seater buses designed for school trips and educational outings in Pune. Featuring child safety measures, experienced drivers, and clean interiors to provide peace of mind for parents and schools."
  },
  {
    "name": "Group Travel Bus Rental",
    "description": "Convenient group travel bus rentals with 32 seater capacity in Pune, suitable for family trips, tours, and social gatherings. Our services focus on comfort, safety, and timely pick-ups to ensure a smooth travel experience."
  },
  {
    "name": "Family Trip 32 Seater Bus",
    "description": "Comfortable 32 seater buses for family trips around Pune, offering spacious seating, clean interiors, and reliable service. Perfect for weekend getaways, celebrations, and multi-generational travel."
  },
  {
    "name": "Tour Bus 32 Seater Pune",
    "description": "Tour-focused 32 seater bus rentals in Pune, ideal for sightseeing, day tours, and multi-day excursions. Customizable routes, knowledgeable drivers, and comfortable amenities ensure an enjoyable travel experience."
  },
  {
    "name": "Office Event Bus Rental",
    "description": "Efficient 32 seater bus rental services in Pune for office events, meetings, and team outings. Provides reliable transportation with professional drivers and flexible scheduling to meet corporate needs."
  },
  {
    "name": "Intercity 32 Seater Bus",
    "description": "Intercity 32 seater bus rentals from Pune for seamless travel between cities. Our buses are well-maintained and equipped for comfort on longer journeys, including driver allowances and toll charges in the package."
  },
  {
    "name": "Non AC 32 Seater Pune",
    "description": "Cost-effective non-AC 32 seater bus rental services in Pune, suitable for short-distance travel and budget-conscious groups. These buses maintain good standards of safety and comfort while providing economical options."
  },
  {
    "name": "Quick 32 Seater Booking Pune",
    "description": "Instant and hassle-free 32 seater bus booking service in Pune with online reservation, real-time availability, and transparent pricing. Ideal for last-minute travel plans and urgent group transportation needs."
  }
],
"tableData": [
  ["32 Seater Bus Hire Pune", "Mid-Size Bus Rental Pune"],
  ["AC 32 Seater Bus Pune", "Wedding 32 Seater Bus Booking"],
  ["Corporate 32 Seater Bus Hire Pune", "32 Seater School Trip Bus"],
  ["Group Travel Bus Rental", "Family Trip 32 Seater Bus"],
  ["Tour Bus 32 Seater Pune", "Office Event Bus Rental"],
  ["Intercity 32 Seater Bus", "Non AC 32 Seater Pune"],
  ["Quick 32 Seater Booking Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable 32 Seater Bus Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers cost-effective and reliable 32 seater bus rentals in Pune, ideal for group travel, corporate events, and special occasions."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating for Large Groups",
    "WhyChoosedescription": "Our 32 seater buses provide ample legroom and comfortable seating, ensuring a pleasant journey for all passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned before every trip to guarantee safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options designed to fit your travel schedule and group size."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers ensure safe, timely, and courteous service, familiar with Pune routes and nearby destinations."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing is all-inclusive, covering fuel, tolls, taxes, and driver allowances for a hassle-free experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Weddings, and Group Travel",
    "WhyChoosedescription": "Perfect for corporate functions, weddings, sightseeing tours, and large group outings in Pune and beyond."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock customer support to assist with bookings and travel inquiries."
  }
]

































  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 32 seater bus rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides 32‑seater buses for rent in Pune. Whether you need transport for weddings, corporate events, outstation trips, or group tours, our fleet is well maintained and designed to offer comfort and safety for all passengers.',
    },
    {
      question: 'Can I get both AC and Non‑AC 32 seater buses?',
      answer: 'Absolutely. We have both AC and non‑AC 32 seater buses available. AC models include air conditioning, cleaner interiors, and more comfortable ride, while non‑AC ones offer a more budget‑friendly option without compromising on safety.',
    },
    {
      question: 'What is the approximate cost for renting a 32 seater bus in Pune?',
      answer: 'For local use, day packages for a 32‑seater bus generally start around **₹10,500 to ₹12,000** for non‑AC, and around **₹11,000 to ₹12,000+** for AC buses (depending on amenities and distance). For outstation trips, rates are higher due to fuel, tolls, driver allowance, and minimum kilometre/day charges.',
    },
    {
      question: 'What amenities are included in a rented 32 seater bus?',
      answer: 'Amenities typically include reclining or pushback seats, overhead luggage storage, a music/audio‑video system, large windows, and for AC models, full climate control. Safety features such as GPS, emergency exits, first aid kits are also standard in our fleet.',
    },
    {
      question: 'Are additional charges applicable beyond the base fare?',
      answer: 'Yes. Charges such as tolls, parking, extra hours or extra kilometres beyond the base package, driver/night allowances (if applicable), permits (for outstation or special areas) are extra. We provide a transparent quote so these are clear upfront.',
    },
    {
      question: 'How far in advance should I book a 32 seater bus in Pune?',
      answer: 'To ensure good availability and better pricing, we recommend booking at least **3‑5 days** in advance for local needs. For outstation trips, events, or during peak seasons (festivals, wedding season), booking **1‑2 weeks ahead** is safer.',
    },
    {
      question: 'Can I arrange multiple pickup and drop points with a 32 seater bus?',
      answer: 'Yes, we can arrange multiple pickup and drop‑off locations across Pune or its outskirts. We’ll plan the route efficiently, keeping in mind extra time or kilometres that may be involved, and reflect those in the pricing.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Deepak Kulkarni",
    position: "Event Coordinator",
    feedback:
      "We rented a 32‑seater AC bus from Vaishnavi Travels for our company offsite. The bus was very clean and comfortable, seats were good, and the ride was smooth even on longer highways. The driver arrived punctually and was very helpful. Price was fair considering the amenities offered.",
    rating: 5,
  },
  {
    name: "Ms. Lata Deshmukh",
    position: "Member, Family Outing Group",
    feedback:
      "Our family outing of 30 people to Lonavala was made easy by Vaishnavi Travels. We took a non‑AC 32 seater bus. It was well‑ventilated and roomy, with good leg space. The stops were well planned. Everyone was comfortable. Booking was easy, and the service was professional all the way through.",
    rating: 5,
    style: "style-2",
  },
];















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32 Seater Bus Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/32-seater-bus-pune.jpg",
  "description": "Rent a 32 seater bus in Pune with Vaishnavi Travels. Perfect for weddings, corporate events, school trips, and family tours. Choose from AC and Non AC options for a comfortable group travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "2540"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5400",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/32-seater-bus-rent-in-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>32 Seater Bus Rent in Pune | AC & Non AC Mid-Size Bus Hire | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent a 32 seater bus in Pune with Vaishnavi Travels. Perfect for weddings, corporate events, school trips, and family tours. Choose from AC and Non AC options for a comfortable group travel experience."
  />
  <meta
    name="keywords"
    content="32 Seater Bus Hire Pune, Mid-Size Bus Rental Pune, AC 32 Seater Bus Pune, Wedding 32 Seater Bus Booking, Corporate 32 Seater Bus Hire Pune, 32 Seater School Trip Bus, Group Travel Bus Rental, Family Trip 32 Seater Bus, Tour Bus 32 Seater Pune, Office Event Bus Rental, Intercity 32 Seater Bus, Non AC 32 Seater Pune, Quick 32 Seater Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thirtytwoseaterbusrentinpune;